var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketStartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62424 16.7403C9.62424 16.3271 9.29467 15.9922 8.88813 15.9922C8.48158 15.9922 8.15201 16.3271 8.15201 16.7403V20.2311C8.15201 20.6442 8.48158 20.9791 8.88813 20.9791C9.29467 20.9791 9.62424 20.6442 9.62424 20.2311V16.7403Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2928 15.9922C15.6993 15.9922 16.0289 16.3271 16.0289 16.7403V20.2311C16.0289 20.6442 15.6993 20.9791 15.2928 20.9791C14.8862 20.9791 14.5566 20.6442 14.5566 20.2311V16.7403C14.5566 16.3271 14.8862 15.9922 15.2928 15.9922Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8488 17.9979C12.8488 17.5847 12.5192 17.2498 12.1127 17.2498C11.7061 17.2498 11.3766 17.5847 11.3766 17.9979V21.2521C11.3766 21.6652 11.7061 22.0001 12.1127 22.0001C12.5192 22.0001 12.8488 21.6652 12.8488 21.2521V17.9979Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.96285C15.3333 5.716 14.3048 3.59097 12.5379 2.18737C12.2234 1.93754 11.7766 1.93754 11.4621 2.18737C9.69521 3.59097 8.66667 5.716 8.66667 7.96285V10.035L7.66667 10.366L7.25722 10.5286C6.4979 10.8302 6 11.5605 6 12.3726V14.5111C6 14.7453 6.23818 14.9054 6.45713 14.8184L7.66667 14.338L8.66667 14.007V14.3992C8.66667 14.731 8.93755 15 9.27171 15H14.7283C15.0624 15 15.3333 14.731 15.3333 14.3992V14.007L16.3333 14.338L17.5429 14.8184C17.7618 14.9054 18 14.7453 18 14.5111V12.3726C18 11.5605 17.5021 10.8302 16.7428 10.5286L16.3333 10.366L15.3333 10.035V7.96285Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketStartAlt);
export default __webpack_public_path__ + "static/media/rocket-start-alt.5daccc905f57cef4ee531ec0a6065ba2.svg";
export { ForwardRef as ReactComponent };